<script lang="ts">
  export let value: string;
  export let placeholder: string;
</script>

<div class="relative flex w-56 shrink-0">
  <span class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400" aria-hidden="true">
    <i class="fa fa-search"></i>
  </span>
  <input
    type="text"
    bind:value
    {placeholder}
    aria-label={placeholder}
    class="block w-full rounded-lg border border-gray-300 py-2 pl-10 pr-3 text-sm text-gray-500 placeholder-gray-400 transition focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
  />
</div>
